
export class CompanySokeMenuPostRequest {
  soke_menu_ids: Array<number>;
}
